import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  addToWishlist,
  removeFromWishlist,
} from "../../../store/wishlistSlice";
import { pushEvent } from "../../../utils";
import { GA_EVENTS } from "../../../utils/constants";

/**
 * @desc Handlers for convention tracker.
 */
export const useHandlers = ({ setShowWishlist, wid }) => {
  // CONSTANTS ----------------------------------------------------------------

  const dispatch = useDispatch();

  // HANDLERS -----------------------------------------------------------------

  /**
   * @desc Dispatch wishlist action and trigger analytics.
   */
  const onFavoriteClick = async (e) => {
    if (
      e &&
      typeof e === typeof {} &&
      e.currentTarget &&
      e.currentTarget.dataset
    ) {
      const { pid, isEmpty, name, isSoldOut } = e.currentTarget.dataset;
      const isAddAction = isEmpty === "true";
      const action = isAddAction ? addToWishlist : removeFromWishlist;
      if (!pid || !wid) {
        toast.error("Wishlist Error. Try again later.");
        return;
      }
      const response = await dispatch(action({ pid, wid }));
      if (action.fulfilled.match(response)) {
        // SEND GA CLICK
        const event_category = isAddAction
          ? GA_EVENTS.ADD_TO_WISHLIST
          : GA_EVENTS.REMOVE_FROM_WISHLIST;
        pushEvent("click", {
          event_category,
          name,
          pid,
          wid,
          isSoldOut,
          date: new Date().toISOString(),
        });
      }
    }
  };

  /**
   * @desc Dispatch tab action.
   */
  const onTabClick = (e) => {
    const { isWishlist } = e.currentTarget.dataset;
    setShowWishlist(isWishlist === "true");
  };

  // HOOK ---------------------------------------------------------------------

  return {
    onFavoriteClick,
    onTabClick,
  };
};
